import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _Array$from from "@babel/runtime-corejs3/core-js/array/from";
import _Set from "@babel/runtime-corejs3/core-js/set";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from "moment";
import { mapGetters, mapActions, mapState } from "vuex";
import CustomDataFieldsForm from "./custom-fields/forms/custom-data-fields-form.vue";
import CreateCustomFieldForm from "./custom-fields/forms/create-custom-field-form.vue";
import { CUSTOM_FIELDS_DEFINITIONS, COLLABORATORS, BOARDS, CUSTOM_FIELDS_TRANSLATION_MAP } from "@Broker/@Modules/clients/board/store/board-getters";
import { CREATE_CUSTOM_FIELD_DEFINITION, UPDATE_CUSTOM_FIELD_DEFINITION, DELETE_CUSTOM_FIELD_DEFINITION, ORDER_CUSTOM_FIELD_DEFINITION, TOGGLE_CUSTOM_FIELD_DEFINITION_VISIBILITY, UPDATE_CUSTOM_FIELDS_DATA, MERGE_CUSTOM_FIELDS_DATA } from "@Broker/@Modules/clients/board/store/board-actions";
import EditFieldsDefinitionsForm from "./custom-fields/forms/edit-fields-definitions-form.vue";
import CustomFieldsLoader from "./custom-fields/custom-fields-loader";
import CollapsibleCard from "@Broker/@Modules/clients/board/client-profile/components/shared/collapsible-card.vue";
import { isEmpty, sortBy, values } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "CustomFields",
  components: {
    CustomDataFieldsForm,
    CreateCustomFieldForm,
    EditFieldsDefinitionsForm,
    CustomFieldsLoader,
    CollapsibleCard
  },
  props: {
    clientProfileId: {
      type: [String, Number],
      required: true
    },
    profile: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean
    },
    boardId: {
      type: [String, Number],
      required: true
    },
    collapse: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      creating: false,
      editing: false,
      currentEditingField: null
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapGetters("BoardStore", [CUSTOM_FIELDS_DEFINITIONS, COLLABORATORS, BOARDS, CUSTOM_FIELDS_TRANSLATION_MAP, "profileCustomFields", "getProfileCollaborators"])), mapState("AccountStore", {
    currentUser(state) {
      return state.userDetails;
    }
  })), mapState("BoardStore", {
    collaborators(state) {
      var _context;
      const clientBoard = state.boards.byId[this.boardId];
      if (!clientBoard) return [];
      const boardCollaborators = values(this.boardCollaborators);
      const allCollaborators = _mapInstanceProperty(_context = [...boardCollaborators, clientBoard.ownerDetails]).call(_context, ({
        username
      }) => username);
      return _Array$from(new _Set(allCollaborators));
    }
  })), {}, {
    customFields() {
      if (isEmpty(this.customFieldsDefinitions)) return [];
      const profileCustomFields = this.profileCustomFields(this.clientProfileId);
      return sortBy(profileCustomFields, [field => {
        var _this$customFieldsDef;
        return _parseInt((_this$customFieldsDef = this.customFieldsDefinitions.byId[field.id]) == null ? void 0 : _this$customFieldsDef.fieldOrder);
      }, field => {
        var _this$customFieldsDef2;
        return moment((_this$customFieldsDef2 = this.customFieldsDefinitions.byId[field.id]) == null ? void 0 : _this$customFieldsDef2.createdAt).unix();
      }]);
    },
    customFieldsDefinitions() {
      return this.CUSTOM_FIELDS_DEFINITIONS(this.boardId);
    },
    boardCollaborators() {
      return this.COLLABORATORS(this.boardId);
    },
    canManageCustomFields() {
      var _context2;
      return _includesInstanceProperty(_context2 = this.collaborators).call(_context2, this.currentUser.username);
    },
    createTooltipText() {
      return this.canManageCustomFields ? this.$t("custom-fields.actions.addCustomField") : this.$t("custom-fields.messages.noAccessToPerformAction");
    },
    editTooltipText() {
      return this.canManageCustomFields ? this.$t("custom-fields.actions.customizeFields") : this.$t("custom-fields.messages.noAccessToPerformAction");
    },
    showCustomDataFieldsForm() {
      return !this.creating && !this.currentEditingField && !this.editing;
    }
  }),
  activated() {
    this.resetCustomFieldsView();
  },
  methods: _objectSpread(_objectSpread({}, mapActions("BoardStore", [CREATE_CUSTOM_FIELD_DEFINITION, UPDATE_CUSTOM_FIELD_DEFINITION, DELETE_CUSTOM_FIELD_DEFINITION, ORDER_CUSTOM_FIELD_DEFINITION, TOGGLE_CUSTOM_FIELD_DEFINITION_VISIBILITY, UPDATE_CUSTOM_FIELDS_DATA, MERGE_CUSTOM_FIELDS_DATA])), {}, {
    saveOnType() {
      this.$emit("save");
    },
    toggleCreating(creating) {
      this.showCollapse();
      this.creating = creating != null ? creating : !this.creating;
      if (this.creating) {
        this.toggleEditing(false);
        this.toggleEditField(null);
      }
    },
    toggleEditing(editing) {
      this.showCollapse();
      this.editing = editing != null ? editing : !this.editing;
      if (this.editing) {
        this.toggleCreating(false);
        this.toggleEditField(null);
      }
    },
    toggleEditField(id) {
      if (id) {
        var _context3;
        const currentField = _findInstanceProperty(_context3 = this.customFields).call(_context3, field => field.id === id);
        this.currentEditingField = _objectSpread(_objectSpread({}, this.customFieldsDefinitions.byId[id]), {}, {
          value: currentField.value
        });
      } else this.currentEditingField = null;
    },
    handleCustomFieldDataChange(value) {
      this.UPDATE_CUSTOM_FIELDS_DATA({
        clientProfileId: this.clientProfileId,
        customFields: value
      });
    },
    async handleCreate(customFieldDefinition) {
      const {
        createCustomFieldForm
      } = this.$refs;
      try {
        createCustomFieldForm.saving = true;
        await this.CREATE_CUSTOM_FIELD_DEFINITION({
          boardId: this.boardId,
          customFieldDefinition
        });
        this.MERGE_CUSTOM_FIELDS_DATA({
          clientProfileId: this.clientProfileId,
          customFieldsDefinitions: this.customFieldsDefinitions
        });
        this.saveOnType();
        createCustomFieldForm.savingStatus = true;
        this.$nextTick(() => {
          this.creating = false;
        });
      } catch (e) {
        createCustomFieldForm.savingStatus = false;
      } finally {
        createCustomFieldForm.saving = false;
      }
    },
    async handleEdit(value) {
      const {
        createCustomFieldForm
      } = this.$refs;
      try {
        createCustomFieldForm.saving = true;
        await this.UPDATE_CUSTOM_FIELD_DEFINITION({
          boardId: this.boardId,
          customFieldDefinition: value
        });
        this.MERGE_CUSTOM_FIELDS_DATA({
          clientProfileId: this.clientProfileId,
          customFieldsDefinitions: this.customFieldsDefinitions
        });
        this.saveOnType();
        createCustomFieldForm.savingStatus = true;
        this.$nextTick(() => {
          this.toggleEditField(null);
        });
      } catch (e) {
        createCustomFieldForm.savingStatus = false;
      } finally {
        createCustomFieldForm.saving = false;
      }
    },
    async handleVisibilityToggle(customFieldDefinitionId) {
      this.TOGGLE_CUSTOM_FIELD_DEFINITION_VISIBILITY({
        boardId: this.boardId,
        customFieldDefinitionId
      });
      this.MERGE_CUSTOM_FIELDS_DATA({
        clientProfileId: this.clientProfileId,
        customFieldsDefinitions: this.customFieldsDefinitions
      });
    },
    async handleDelete({
      id: customFieldDefinitionId,
      origin
    }) {
      if (origin === "definition") {
        await this.DELETE_CUSTOM_FIELD_DEFINITION({
          boardId: this.boardId,
          customFieldDefinitionId
        });
        this.MERGE_CUSTOM_FIELDS_DATA({
          clientProfileId: this.clientProfileId,
          customFieldsDefinitions: this.customFieldsDefinitions
        });
      } else if (origin === "orphan") {
        var _context4;
        this.handleCustomFieldDataChange(_filterInstanceProperty(_context4 = this.customFields).call(_context4, ({
          id
        }) => customFieldDefinitionId !== id));
      }
      this.saveOnType();
    },
    handleOrder(customFieldDefinitions) {
      this.ORDER_CUSTOM_FIELD_DEFINITION({
        boardId: this.boardId,
        customFieldDefinitions
      });
    },
    resetCustomFieldsView() {
      this.creating = false;
      this.editing = false;
      this.currentEditingField = null;
    },
    showCollapse() {
      this.$refs.collapseCustomFields.handleShow();
    }
  })
});